export default __webpack_public_path__ + "static/media/8.f438b525.jpeg";